// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "article.pageSearch .inputBox.with{max-width:235px}@media screen and (max-width:1000px){article.pageSearch .inputBox.with{max-width:350px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
